
import { HttpResponse } from "../auth/AuthInterface";

export const defaultCubiculo: CubiculosProps = { idTipoCubiculo: 0, numeroCubiculo: 0, usuario: '', idEstatus: 0, estatus: '', idUnidad: 0, unidad: '', liberar: false }; 

export interface CubiculosProps {
    idTipoCubiculo?:         number;
    numeroCubiculo?:         number;
    idEstatus?:              number;
    estatus?:                string;
    usuario?:                string;
    unidad?:                 string;
    idUnidad?:               number;
    liberar:                 boolean;
}

export interface ConsultaCubiculosParams {
    idEstatus?:              number;
    idUnidad?:               number;
}

export interface ObtenerCubiculoParams {
    idTipoCubiculo:            number;
    idUsuario?:                number;
    idUnidad?:                 number;
}

export interface LiberarCubiculoParams {
    idTipoCubiculo: number;
}

export interface OcuparCubiculoResponse extends CubiculosProps, HttpResponse { }

export interface AsignarCubiculoAdminParams {
    idTipoCubiculo:            number;
    idUsuario:                 string;
}

